const employees = [
  { icon: 'ri-rocket-2-line', title: 'Сильный самостоятельный сотрудник', desc: 'Как не демотивировать его избыточным контролем. Такому сотруднику нужны зона автономии, понятные рамки и обратная связь по результату, а не по каждому действию.' },
  { icon: 'ri-user-settings-line', title: 'Слабый сотрудник', desc: 'Как понять, в чём проблема: в компетенциях, мотивации или ответственности. От причины зависит решение — обучение, разговор о мотивации или управленческое требование.' },
  { icon: 'ri-question-answer-line', title: 'Сотрудник, который постоянно спорит', desc: 'Как использовать несогласие конструктивно и не допустить разрушения управленческой роли. Выслушать аргументы, отделить предмет от эмоций и вернуть разговор к задаче.' },
  { icon: 'ri-shield-user-line', title: 'Сотрудник, который избегает ответственности', desc: 'Как определить причину и изменить модель взаимодействия: прояснить ожидания, передать полномочия, зафиксировать договорённости и точки контроля.' },
  { icon: 'ri-star-line', title: '«Звезда» команды', desc: 'Как не допустить ситуации, когда результат подразделения зависит от одного человека. Распределять ключевые компетенции и развивать дублирование знаний.' },
  { icon: 'ri-user-add-line', title: 'Новый сотрудник', desc: 'Как сочетать адаптацию, контроль и постепенное увеличение самостоятельности, не перегружая его на старте и не оставляя без поддержки.' },
];

export default function DifficultEmployees() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Как руководителю работать с разными сотрудниками
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Управление сильными и сложными сотрудниками требует разного подхода — но единых правил и стандартов
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {employees.map((e) => (
            <div key={e.title} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${e.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{e.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{e.desc}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-sm text-gray-500 mt-10">
          Развитие сотрудников и работа с кадровым резервом — тема отдельной программы «Наставничество и развитие сотрудников» (скоро на сайте).
        </p>
      </div>
    </section>
  );
}